import React, { useEffect, useState } from 'react';
import api from 'api/profileApi';
import { X as CloseButton } from 'react-feather';
import { useRouter } from 'next/router';
import useShowNotification from './useShowNotification';

const RewardNotificationCard = () => {
  const router = useRouter();

  const [showNotif, setShowNotif] = useState(false);
  const { showAlert, title, description, cta } = useShowNotification();

  useEffect(() => {
    if (showAlert) {
      setShowNotif(true);
    }
  }, [showAlert]);

  if (!showNotif) return null;

  return (
    <div className="card bg-purple-200 relative h-fit">
      <div
        className="absolute top-4 right-4 z-10 cursor-pointer"
        onClick={() => {
          setShowNotif(false);
          api.updateUserNotificationReminder();
        }}
      >
        <CloseButton size={16} color="white" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-base font-bold text-white">{title}</p>
        <p className="text-white">
          {description}{' '}
          <span
            className="underline cursor-pointer"
            onClick={() => {
              setShowNotif(false);
              api.updateUserNotificationReminder();
              router.push('/rewards');
            }}
          >
            {cta}
          </span>
        </p>
      </div>
    </div>
  );
};

export default RewardNotificationCard;
